import { styled } from '@mui/material';
import CloseButton from 'components/CloseButton';

const DialogCloseIcon = styled(CloseButton)(() => ({
	position: 'absolute',
	top: '16px',
	right: '8px',
}));

export default DialogCloseIcon;
